import Vue from 'vue'
import { Toast } from 'vant';
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'
import Vant, { Swipe, SwipeItem, List, Popup, Cell, Button } from 'vant';
import VConsole from 'vconsole'
import setRem from './libs/rem.js';
import apiServe from './libs/apiServe.js';
import publicFunction from './libs/publicFunction.js';
// import aMap from './libs/aMap.js';
import 'vant/lib/index.css';
import './assets/css/index.css';
import loading from './components/loding/loading';
import './libs/debounce' //点击事件的防抖和节流 v-debounce="[() => { submit() }, 500]"
import configUrl from '@/libs/config';
import VueCookies from 'vue-cookies';
import vueggPublic from 'vuegg-public'
import VueClipboard from 'vue-clipboard2'
import trackFn from "../public/js/trackFn";
import bridgeSystem from '../public/js/bridgeSystem';
import uniondrug from 'uniondrug';
import '@babel/polyfill'
import Es6Promise from 'es6-promise'
import waterfall from "vue-waterfall2";


//新埋点
import autotrack from "../public/js/autotrack-1.22.6.js";
import newTrackFn from '../public/js/trackFn-1.22.6.js'
 
require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.use(VueClipboard)
Vue.use(waterfall);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(vueggPublic);
setRem();//配置rem 后面宽度使用px自动转换rem,屏宽750；
Vue.use(Vant);//UI框架组建因为懒所以全部引用
Vue.use(loading);//自定义的加载中loading

if (location.host.indexOf('turboradio.cn') > -1 || location.host.indexOf('uniondrug.net') > -1 || VueCookies.get("mobile") == '18637336409') {
    let vConsole = new VConsole()
}
// 13655175638 韩奇
// 18637336409 翟志然

// let handler = monitor.bind(function (e) { //数据上报组件
//     e = e || window.event;
//     monitor._trackEvent(e, 'aaa');
// }, this);
// document.addEventListener('click', handler, true);
/**
 Vue.prototype.$bridge = Bridge;//与IOS和安卓数据交互组建,
 /https://www.npmjs.com/package/qrcode.vue二维码控件

 Vue.config.productionTip = false;
 */

// vuex
Vue.prototype.$store = store;
// api
Vue.prototype.$api = apiServe;
Vue.prototype.$http = axios;
// 高德地图
// Vue.prototype.$aMap = aMap;
// 环境变量配置
Vue.prototype.$configUrl = configUrl.config();
// cookies
Vue.prototype.$cookies = VueCookies;
// 公共js方法
Vue.prototype.$publicFunction = publicFunction;
// 公共埋点方法
Vue.prototype.$trackFn = trackFn;
Vue.prototype.$bs = bridgeSystem;

//全新埋点注入
// 神策埋点--------start--------
// 使用sensor1.22.6埋点 老的废弃
autotrack.autoTfn();
newTrackFn.clearAllRegister();
Vue.prototype.$newTrackFn = newTrackFn;

bridgeSystem.resolveSetScavenging().then((e) => {

})

router.afterEach(to => {
    const u = navigator.userAgent.toLowerCase();
    if (
        u.indexOf("likemacosx") < 0 ||
        u.match(/MicroMessenger/i) != "micromessenger"
    )
        return;
    if (to.path !== global.location.pathname) {
        location.assign(to.fullPath);
    }
});

router.beforeEach((to, from, next) => {
    //动态修改页面title
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return ('');
    }

    function login() {
        let params = {
            'jumpType': ''
        }
 
        if (getQueryVariable("jumpType")) {
            params = {
                'jumpType': getQueryVariable("jumpType")
            }
        } else {
            delete (params['jumpType'])
        }
        // 初始化
        apiServe.member(params).then((res) => { 

            if (res.errno === '0') {
                const { memberId} = res.data
                if (res.data.jumpUrl && res.data.isJump == '1') {
                    window.location.href = res.data.jumpUrl
                    return;
                }
                // 记录用户
                //登录，将神策匿名id与药联的memberId关联起来
                newTrackFn.sendLogin(memberId);

                sessionStorage.setItem('user', JSON.stringify(res.data));
                VueCookies.set("mobile", res.data.mobile)
                sessionStorage.setItem('login', 'login');
                sessionStorage.setItem('out', 'out');
                sessionStorage.setItem('inpage', 'inpage')
                if (sessionStorage.getItem('out') !== 'out') {
                    if (to.path === '/recruitHome') {
                        location.assign('/distribution' + to.fullPath)
                    } else if (res.data.isAgent === '0') {
                        location.href = '/distribution/recruitHome'
                    } else {
                        next()
                    }
                } else {
                    next()
                }
            }
        });
    }

    sessionStorage.setItem("isWexin", isWexin())

    function isWexin() {
        var userAgent = navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(userAgent)) {
            console.log("微信")
            return "wechat"
        } else {
            console.log("h5")
            return "h5"
        }
    }

    // 获取主域的token
    let common = uniondrug.getToken(); //VueCookies.get('union_token');
    console.log('common', common)
    //药店宝token
    let redirect_uri = encodeURIComponent(window.location.href);
    if (to.meta.requireAuth) {
        // 药店宝打开
        var loginType;
        if (to.query.loginType) {
            if (to.query.loginType.constructor === Array) {
                loginType = to.query.loginType[0]
            } else {
                loginType = to.query.loginType
            }
        }
        if (loginType == "ydbapp" || sessionStorage.getItem('state') == 'ydb') {
            sessionStorage.setItem('state', 'ydb')
            store.commit('data/stateFrom', sessionStorage.getItem('state'))
            if (to.query.token) {
                sessionStorage.setItem('firstUrlQuery', JSON.stringify(to.query))
            }
            if (common && sessionStorage.getItem('inpage') === 'inpage') {
                login();
            } else {
                Vue.$loading.show();
                uniondrug.unionLogin().then(token => {
                    console.log('token', token);
                    Vue.$loading.hide();
                    login();
                }).catch(err => {
                    Toast(err);
                });
                // let params = {
                //     'token': to.query.token
                // }
                // apiServe.assistant(params).then((res) => {
                //     if (res.errno === '0') {
                //         if (res.data.token) {
                //             VueCookies.set("union_token", res.data.token, 60 * 60 * 24 * 7, '/', configUrl.config().domin);
                //             axios.defaults.headers.common['Authorization'] = 'Bearer ' + VueCookies.get('union_token');
                //             login();
                //         }
                //     }
                // });
            }
        } else {
            // 本地调试
            if (location.host.indexOf('localhost:8080') > -1) {
                VueCookies.set('union_token', 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJJZCI6MTU5NjkxMjQsInd4T3BlbmlkIjoib2YtRlh3emdsWWlFMU0yZVdrTmxZbEhsRER5ayIsInZlcnNpb24iOnsia2V5IjoiQVVUSF9tb2JpbGVfMTU5NjkxMjQiLCJ2YWx1ZSI6IjEifSwiaW5mbyI6eyJuYW1lIjoiXHU1ZTM4XHU0ZWU1XHU2NTg3IiwibW9iaWxlIjoiMTU4MDA5ODUyODkifSwiY2hhbm5lbCI6eyJ0eXBlIjoibW9iaWxlIn19.jQUYgFUIeLD_9trM7_aXnw4qx7PxpYvgepxaNxILBqEfB--Jt-Ovpa8GthBxNYnUGO13fYWOlZjiMtw5Gp8dBQy-fCuMOLRjq17hqhOGr0hNPRCtODX9KolWRp_EjugrrN4cWty5qN9LBPIrbvaRbHLBHr_vSspHybm0US8d8Of-4iU1hQtLGlwpFcyy6r2zLOdSpFx8Cb1tDLOt3FRfFKvrznGS02RLzyydBriGUWh8YctUqwvwIUUOQ3qD04Rlh6hJ2E_6_XsSXuUj81nDx9bfJ_bYcWjD_uAdgZNsSMV-2SZGob8S2Qc4jzAHs5HtCwk-nX-BTXXYJa1NBJloLw')
            }
            sessionStorage.setItem('state', 'wx')
            store.commit('data/stateFrom', sessionStorage.getItem('state'))
            if (uniondrug.getToken()) {
                //if (VueCookies.get('union_token')) {
                login();
            } else {
                window.location.replace(configUrl.config().auth + '/authority?redirect_uri=' + redirect_uri)
            }
        }

    } else {
        next();
    }
});
// console.log('route',router)

// window.addEventListener('beforeunload', function () {
//     VueCookies.remove('union_token')
// },false)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
